(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["em"] && !Shopify.designMode) return;
  try {
    /*
    On desktop, when 'Thumbnails' is picked as the desktop slideshow controls style, the product
    media gallery in grid presentation shows the slideshow's thumbnail rail next to the
    natural-flow image grid (see media.css). Those thumbnails are wired by the theme to drive the
    hidden slideshow, so on desktop we intercept them: a click scrolls the page to the matching
    grid image, and an IntersectionObserver keeps `aria-selected` on the thumbnail whose image
    crosses the middle of the viewport. On mobile the slideshow is the visible presentation and
    the thumbnails keep their stock behavior.
  */
  (() => {
    const desktop = window.matchMedia('(min-width: 750px)');

    const init = () => {
      for (const gallery of document.querySelectorAll(
        '.product-information__media media-gallery.media-gallery--grid'
      )) {
        const thumbs = gallery.querySelectorAll(
          'slideshow-controls[thumbnails]:not(.media-gallery__mobile-controls) .slideshow-controls__thumbnail'
        );
        const items = gallery.querySelectorAll('.media-gallery__grid > *');
        if (!thumbs.length || !items.length) continue;

        const select = (index) => {
          thumbs.forEach((thumb, i) => {
            if (i === index) {
              thumb.setAttribute('aria-selected', 'true');
            } else {
              thumb.removeAttribute('aria-selected');
            }
          });
        };

        thumbs.forEach((thumb, i) => {
          thumb.addEventListener(
            'click',
            (event) => {
              if (!desktop.matches) return;
              event.preventDefault();
              event.stopImmediatePropagation();
              items[i]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            },
            true
          );
        });

        const itemList = [...items];
        const inBand = new Set();
        const observer = new IntersectionObserver(
          (entries) => {
            if (!desktop.matches) return;
            for (const entry of entries) {
              if (entry.isIntersecting) {
                inBand.add(entry.target);
              } else {
                inBand.delete(entry.target);
              }
            }
            const current = itemList.findIndex((item) => inBand.has(item));
            if (current > -1) select(current);
          },
          { rootMargin: '-45% 0px -45% 0px' }
        );
        itemList.forEach((item) => observer.observe(item));
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mote"] && !Shopify.designMode) return;
  try {
    (() => {
    const IMAGE = '.product-media-container:first-of-type .product-media__image';
    const STEP = 60;
    const SPREAD = 900;
    const THRESHOLDS = [0];
    const armed = new WeakSet();
    const pending = new Map();
    const staging = [];
    const queue = [];
    let observer = null;
    let margin = -1;
    let anchored = false;
    let ticking = false;
    let lastAt = 0;
    let resizeTimer = 0;
    document.documentElement.setAttribute('data-mote-reveal', '');
    const tick = (now) => {
      ticking = false;
      let earliest = Infinity;
      for (const item of queue) {
        if (item.at < earliest) earliest = item.at;
      }
      if (now - earliest > STEP * 2) {
        const shift = now - earliest;
        for (const item of queue) item.at += shift;
        lastAt += shift;
      }
      for (let i = queue.length - 1; i >= 0; i--) {
        const item = queue[i];
        if (!item.image.isConnected) {
          queue.splice(i, 1);
        } else if (now >= item.at) {
          item.image.setAttribute('data-mote-revealed', '');
          queue.splice(i, 1);
        }
      }
      if (queue.length && !ticking) {
        ticking = true;
        requestAnimationFrame(tick);
      }
    };
    const anchor = (start) => {
      anchored = false;
      const fresh = staging.filter((item) => item.fresh).sort((a, b) => (a.image.compareDocumentPosition(b.image) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
      const late = staging.filter((item) => !item.fresh);
      staging.length = 0;
      const step = Math.min(STEP, SPREAD / Math.max(fresh.length - 1, 1));
      fresh.forEach((item, index) => {
        item.at = start + index * step;
        lastAt = Math.max(lastAt, item.at);
        queue.push(item);
      });
      for (const item of late) {
        item.at = Math.min(Math.max(start, lastAt + STEP), start + SPREAD);
        lastAt = Math.max(lastAt, item.at);
        queue.push(item);
      }
      if (queue.length && !ticking) {
        ticking = true;
        requestAnimationFrame(tick);
      }
    };
    const stage = (image, fresh) => {
      if (armed.has(image)) return;
      armed.add(image);
      staging.push({ image, fresh, at: 0 });
      if (!anchored) {
        anchored = true;
        requestAnimationFrame(anchor);
      }
    };
    const fully = (entry) => {
      return entry.isIntersecting && entry.intersectionRatio > 0;
    };
    const tryStage = (gallery, fresh) => {
      const state = pending.get(gallery);
      if (!state || !state.visible || !state.image.complete) return;
      pending.delete(gallery);
      observer.unobserve(gallery);
      stage(state.image, fresh);
    };
    const onIntersect = (entries) => {
      for (const entry of entries) {
        const state = pending.get(entry.target);
        if (!state) continue;
        state.visible = fully(entry);
        if (!state.visible) continue;
        if (state.image.complete) {
          tryStage(entry.target, true);
        } else if (!state.waiting) {
          state.waiting = true;
          const loaded = () => tryStage(entry.target, false);
          state.image.addEventListener('load', loaded, { once: true });
          state.image.addEventListener('error', loaded, { once: true });
        }
      }
    };
    const headerHeight = () => {
      const header = document.querySelector('#header-component[sticky]');
      return header ? Math.round(header.getBoundingClientRect().height) : 0;
    };
    const build = () => {
      const next = headerHeight();
      if (observer && next === margin) return;
      margin = next;
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(onIntersect, { threshold: THRESHOLDS, rootMargin: '-' + margin + 'px 0px 0px 0px' });
      for (const gallery of pending.keys()) observer.observe(gallery);
    };
    const watch = (gallery) => {
      if (pending.has(gallery)) return;
      const image = gallery.querySelector(IMAGE);
      if (!image || armed.has(image)) return;
      pending.set(gallery, { image, visible: false, waiting: false });
      observer.observe(gallery);
    };
    const scan = (root) => {
      if (root.matches?.('.card-gallery')) watch(root);
      for (const gallery of root.querySelectorAll?.('.card-gallery') ?? []) watch(gallery);
    };
    const prune = () => {
      for (const gallery of pending.keys()) {
        if (!gallery.isConnected) {
          observer.unobserve(gallery);
          pending.delete(gallery);
        }
      }
    };
    build();
    scan(document.body);
    addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 250);
    });
    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) scan(node);
        }
        if (record.removedNodes.length) prune();
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();
  (() => {
    const strip = (root) => {
      for (const dd of root.querySelectorAll('.cart-items__variant dd')) {
        const text = dd.textContent;
        const clean = text.replace(/,\s*$/, '');
        if (clean !== text) dd.textContent = clean;
      }
    };
    const init = () => {
      const root = document.getElementById('cart-drawer');
      if (!root) return;
      strip(root);
      new MutationObserver(() => strip(root)).observe(root, { childList: true, subtree: true, characterData: true });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  (() => {
    document.addEventListener('slideshow:select', (event) => {
      const { slide, trigger, userInitiated } = event.detail || {};
      if (!slide || trigger !== 'select' || !userInitiated) return;
      if (!slide.closest('.product-information__media')) return;
      if (getComputedStyle(slide.parentElement).flexDirection !== 'column') return;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      slide.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
